<template>
  <div class="flex-with-gap">
    <span v-if="multipleEans.length === 1" class="cinza-0-14px"><strong>EAN: </strong>{{ singleEan }}</span>

    <popover-edit
      v-else-if="multipleEans.length > 1"
      ref="popoverMenu"
      :title="offer.name"
      subtitle="Múltiplos EANs"
      :disabled="disabled"
      :clickable-text="getMultipleEanText"
      @cancel="cancel"
      @submit="submit"
    >
      <div class="d-flex flex-column">
        <span class="eans-title">EANs</span>
        <div class="custom-divider" />
        <div v-for="ean in multipleEans" :key="ean">
          <v-checkbox v-model="selectedEans" class="reset-margin" :label="ean" :value="ean" color="marca-0-l20" dense hide-details />
          <div class="custom-divider" />
        </div>
      </div>
    </popover-edit>
  </div>
</template>

<script>
import PopoverEdit from '../PopoverEdit.vue'

export default {
  name: 'ProductEan',
  components: {
    PopoverEdit,
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isVoucherDigital: {
      type: Boolean,
      default: false,
    },
    isInsideProductsGroup: {
      type: Boolean,
      default: false,
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    selectedEans: [],
  }),
  computed: {
    singleEan() {
      if (this.isVoucherDigital && !this.isInsideProductsGroup) {
        return this.offer?.trigger_products[0]?.ean
      }
      return this.offer?.ean
    },

    multipleEans() {
      if (this.isVoucherDigital && !this.isInsideProductsGroup) {
        return this.offer?.trigger_products[0]?.eans
      } else if (this.isVoucherDigital) {
        return this.offer.eans
      }
      return this.offer?.product?.eans
    },

    getMultipleEanText() {
      return {
        bold: 'EANs: ',
        normal: this.previewMode ? 'Múltiplos' : `${this.offer.eans.length}/${this.offer.product.eans.length}`,
      }
    },
  },
  mounted() {
    this.resetSelecttedEans()
  },
  methods: {
    submit() {
      this.offer.eans = this.selectedEans
      this.$refs.popoverMenu.close()
    },
    resetSelecttedEans() {
      this.selectedEans = this.offer.eans
    },
    cancel() {
      this.resetSelecttedEans()
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-with-gap {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.cinza-0-14px {
  font-size: 14px;
  color: $cinza-0;
}

.eans-title {
  font-size: 14px;
  font-weight: bold;
  color: #31363b;
}

.custom-divider {
  margin-top: 8px;
  border-bottom: 1px solid $cinza-l70;
}

.reset-margin {
  margin: 0px;
  margin-top: 8px;
}
</style>
